import { NgModule } from '@angular/core';
import { ProfilePictureComponent } from './profile-picture.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ProfilePictureComponent],
  imports: [CommonModule],
  exports: [ProfilePictureComponent],
})
export class ProfilePictureModule {}
